module.exports = __webpack_public_path__ + "static/img/fp_logo_strip.628c00d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v7/fp_logo_strip.png
// module id = z367
// module chunks = 0